import { render, staticRenderFns } from "./edit-investment-request.vue?vue&type=template&id=ad61b546&scoped=true"
import script from "./edit-investment-request.vue?vue&type=script&lang=js"
export * from "./edit-investment-request.vue?vue&type=script&lang=js"
import style0 from "./edit-investment-request.vue?vue&type=style&index=0&id=ad61b546&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad61b546",
  null
  
)

export default component.exports